module.exports = __webpack_public_path__ + "static/img/banner1.f961f9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner1.png
// module id = KC9k
// module chunks = 1